module.exports = __webpack_public_path__ + "img/unloading_blk.7978dd1f.svg";